import { RolePermissionScope } from '@bechtel/ht-types';
import { get } from 'lodash';
import { FC, useEffect } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import { ErrorBoundary } from '~/components';
import { useGetRolePermissionList } from '~/hooks';
import { CreateUser } from './create';
import { UserDetail } from './detail';
import { UserItemList } from './list';
import { ProjectAdminSubContainerStyled } from './styled';
export const ManageUsers: FC = () => {
  const { getRolePermissionList, data: rolePermissionScopeData } = useGetRolePermissionList();
  useEffect(() => {
    getRolePermissionList();
  }, []);
  const rolePermissionList: RolePermissionScope[] = get(
    rolePermissionScopeData,
    'searchRolePermissionScopes.items',
    []
  );
  return (
    <ErrorBoundary>
      <ProjectAdminSubContainerStyled style={{ overflowY: 'hidden' }}>
        <ErrorBoundary>
          <UserItemList />
        </ErrorBoundary>
        <ErrorBoundary>
          <Routes>
            <Route path={`:userId`} element={<UserDetail rolePermissionList={rolePermissionList} />} />
            <Route path="/" element={<UserDetail rolePermissionList={rolePermissionList} />} />
            <Route path={`/user/create`} element={<CreateUser rolePermissionList={rolePermissionList} />} />
          </Routes>
          <Outlet></Outlet>
        </ErrorBoundary>
      </ProjectAdminSubContainerStyled>
    </ErrorBoundary>
  );
};

export default ManageUsers;
